module.exports = __webpack_public_path__ + "img/font2.1237b9c8.png";